import { render } from "./month-data.vue?vue&type=template&id=fa3fdeb4&scoped=true"
import script from "./month-data.vue?vue&type=script&lang=js"
export * from "./month-data.vue?vue&type=script&lang=js"

import "./month-data.vue?vue&type=style&index=0&id=fa3fdeb4&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa3fdeb4"]])

export default __exports__